<template>
  <erp-s-field
      :view="this.fieldView || 'tl'"
      :label="label || 'Status'"
      :helper="helper"
      :helper-position="helperPosition || 'lb'"
      :error="error"
      :label-width="labelWidth"
      :style="fieldStyle"
  >
    <erp-select
        @input="__set"
        :multiple="multiple"
        :placeholder="placeholder || 'Qualquer'"
        :options="status"
        v-model="model"
        propoverClass="select-status-def1"
        :disable="disable"
        :style="inputStyle"
    >
      <template v-slot:itemLabel="props">
        <status-cliente :cliente="mapperProps(props.opt)" />
      </template>
    </erp-select>
  </erp-s-field>
</template>

<script>
import SelectMixin from '../../../../../mixins/SelectMixin'
import StatusCliente from './StatusCliente'

export default {
  name: 'StatusSelect',
  mixins: [SelectMixin],
  props: {},
  data () {
    return {}
  },
  computed: {
    status () {
        return [
          {
            label: 'Ativo',
            value: true,
            class: 'text-positive'
          },
          {
            label: 'Inativo',
            value: false,
            class: 'text-negative'
          }
        ]
    }
  },
  components: {StatusCliente},
  methods: {
    __updateInternal () {
      this.$nextTick(() => {
        if (this.value !== 'undefined' && this.value !== null && this.model === null) {
          let _cp = JSON.stringify(this.value) // force to update datepicker with actual value
          this.model = ''
          setTimeout(() => {
            this.model = JSON.parse(_cp)
          }, 1)
        }
      })
    }
  }
}
</script>
